import React from 'react'
import { Link } from 'react-router-dom'

import { useListData, useToggle } from '../modules'

import Receive from '../components/resusable/receive'
import NewStation from '../components/modals/newstation'

function Stations() {
    const [stationModal, toggleStationModal] = useToggle()

    const [{ loading, error, fetch }, { list: stations }] = useListData('dispensingStations', null, { notify: true }, 'stations')

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <NewStation
                onPerform={ fetch }
                toggle={toggleStationModal}
                visible={stationModal} />
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <ul className="flex flex-wrap justify-center sm:justify-start mb-8 sm:mb-0 -space-x-3 -ml-px" />
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    <button onClick={toggleStationModal} className="btn hisani-btn-green text-white">
                        <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                            <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                        </svg>
                        <span className="hidden xs:block ml-2">New Station</span>
                    </button>
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-gray-50 shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100">
                    <h2 className="font-semibold text-gray-800">Stations</h2>
                </header>
                <div className="max-w-7xl mx-auto px-10 lg:px-6 py-1">
                    <Receive
                        error={error}
                        loading={loading}
                        progress>
                        {
                            stations.length > 0 ?
                                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-4 xl:grid-cols-6 py-8">
                                    {
                                        stations.map(station =>
                                            <Link to={ `/app/stations/${station._id}` }>
                                                <div className="p-6 col-span-1 md:col-span-2 lg:col-span-1 bg-white flex items-center space-x-6 rounded-lg shadow-md hover:scale-105 transition transform duration-500 cursor-pointer">
                                                    <div>
                                                        <h1 className="text-xl font-bold text-gray-700 mb-2">{ station.name }</h1>
                                                        <p className="text-gray-600 w-80 text-sm">{ station.major }</p>
                                                    </div>
                                                </div>
                                            </Link>
                                        )
                                    }
                                </div>
                            : 
                                <div className="flex font-bold text-xl justify-center items-center">
                                    <h2>Please click above to add stations</h2>
                                </div>
                        }
                    </Receive>
                </div>
            </div>
        </div>
    )
}

export default Stations